import React from 'react'
import { newProfileIcon } from '../../../assets/logos/icons'
import { Tooltip } from '@progress/kendo-react-tooltip'
import { useTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core'
import { PanelBarGLPure } from '../../pures'
import { ChatBoxGLPure } from '..'
import './team-chat.pure.css'

/**
 * Componente reutilizable para mostrar un chat de equipo con avatares de miembros
 * @function TeamChatPure
 * @param {{
 *   usersChat: Object,
 *   conversation: Array,
 *   membersChat: Array<{name: string, avatarUrl: string}>,
 *   handleInputChangeChat: Function,
 *   createMessage: Function,
 *   disabledChat: boolean,
 *   titleChat: string,
 *   widthChat: number,
 *   heightChat: number,
 *   titlePanel: string,
 *   placeholderChat: string
 * }} props - Propiedades del componente
 * @param {Object} props.usersChat - Usuario actual del chat
 * @param {Array} props.conversation - Arreglo de mensajes de la conversación
 * @param {Array<{name: string, avatarUrl: string}>} props.membersChat - Miembros del chat con sus avatares
 * @param {Function} props.handleInputChangeChat - Manejador para cambios en el input de archivos
 * @param {Function} props.createMessage - Función para crear un nuevo mensaje
 * @param {Function} [props.onMarkAsRead] - Callback invocado al montar el chat para marcar mensajes como leídos
 * @param {boolean} [props.disabledChat=false] - Si el chat está deshabilitado
 * @param {string} [props.titleChat] - Título del chat (opcional, usa i18n por defecto)
 * @param {string} [props.titlePanel] - Título del panel que contiene el chat (opcional, usa i18n por defecto)
 * @param {number} [props.widthChat=1200] - Ancho del chat en píxeles
 * @param {number} [props.heightChat=300] - Altura del chat en píxeles
 * @param {string} [props.placeholderChat] - Placeholder del input (opcional, usa i18n por defecto)
 * @returns {JSX.Element} Componente de chat de equipo
 */
const TeamChatPure = (props) => {
    const { t } = useTranslation()

    const {
        usersChat,
        titleChat,
        titlePanel,
        membersChat,
        conversation,
        createMessage,
        placeholderChat,
        widthChat = 1200,
        heightChat = 300,
        containerHeight,
        disabledChat = false,
        handleInputChangeChat,
        onMarkAsRead,
    } = props

    return (
        <div className='teamChatPure-container'>
            <PanelBarGLPure
                expandedPanel={true}
                titlePanel={titlePanel || t('newSignatureDetailView.comments.team')}
                className='documentPanelBarDocumentRequested'
                id='teamChatPure-panelBar'
            >
                <Grid className='teamChatPure-header'>
                    <span className='teamChatPure-title'>
                        {titleChat || t('panelBarHLPure.title.chat')}
                    </span>
                    <div className='teamChatPure-avatars-container'>
                        {membersChat && membersChat.map((item, index) => (
                            <div key={index}>
                                <Tooltip
                                    openDelay={600}
                                    position='bottom'
                                    anchorElement='target'
                                    tooltipClassName='tooltipGeneralStyle'
                                >
                                    <div>
                                        <img
                                            title={item.name}
                                            src={
                                                item.avatarUrl && item.avatarUrl !== ''
                                                    ? item.avatarUrl
                                                    : newProfileIcon
                                            }
                                            className='teamChatPure-avatar'
                                            alt={item.name}
                                        />
                                    </div>
                                </Tooltip>
                            </div>
                        ))}
                    </div>
                </Grid>
                <div style={{ height: containerHeight || heightChat }}>
                    <ChatBoxGLPure
                        user={usersChat}
                        conversation={conversation}
                        widthChat={widthChat}
                        heightChat={heightChat}
                        placeholderChat={placeholderChat || t('chatBoxGLPure.placeholder')}
                        handleInputChange={handleInputChangeChat}
                        createMessage={createMessage}
                        disabled={disabledChat}
                        mentionMembers={membersChat}
                        onMarkAsRead={onMarkAsRead}
                    />
                </div>
            </PanelBarGLPure>
        </div>
    )
}

export default TeamChatPure
